import { Component, Input, OnInit, Output, ViewChild } from "@angular/core";

import { GlobalDataService } from "../../_services/global-data.service";
import { FormGroup } from "@angular/forms";

import { SelectMenuOption } from "../../form/select-menu/select-menu.component";
import { LoggerService } from "../../modules/logger/logger.service";
import { SelectMenuAppearance } from "../../form/models/select-menu-apearance";
import { MultiSelectMenuComponent } from "../../form/multi-select-menu/multi-select-menu.component";

@Component({
  selector: "select-layers",
  templateUrl: "select-layers.component.html",
  styleUrls: ["select-layers.component.scss"],
})
export class SelectLayersComponent implements OnInit {
  @Input("appearance") public appearance: SelectMenuAppearance;
  @Input("length") public length: number;
  @ViewChild("multiSelectMenuComponent")
  public multiSelectRef: MultiSelectMenuComponent;

  public allSelectedLayers: SelectMenuOption[] = [];

  public layerOptions: SelectMenuOption[] = [];

  constructor(
    private globalDataService: GlobalDataService,
    private logger: LoggerService
  ) {}

  public async initData() {
    try {
      const result = await this.globalDataService.getGlobalData();

      if (result.success === false) {
        this.logger.error("No global data found.");
        return;
      }

      if (result.success === true) {
        const grades = result.data.grades as Array<{
          id: number;
          name: string;
        }>;
        this.layerOptions = grades.map((grade) => ({
          key: grade.id.toString(),
          text: grade.name,
          customValue: grade,
        }));
      }
    } catch (error) {
      this.logger.error("Error fetching organ data:", error);
    }
  }

  public ngOnInit() {
    this.initData().then();
  }

  public onLayerSelected(selectedOptions: SelectMenuOption[]) {
    this.allSelectedLayers = selectedOptions
      .map((opt) => opt.customValue)
      .filter((o) => o);
  }

  public getSelectedLayers() {
    return this.allSelectedLayers.map((layer) => layer.key);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/select-layers/select-layers.component.ts